<template>
  <drag-modal :visible="$store.state.dislog.stepbox" @cancel="close" title='选择进度' width='950px'>
    <div class="dl" v-for='(i, index) in Step' :key='index'>
      <!-- <div class="li" v-for='(i,index) in Step' :key='index' @click='lick(i)'>{{i.name}}</div> -->
      <div class="dt">{{ stepTit[index] }}</div>
      <div class="dd">
        <div class="a" v-for='(j, ind) in i' :key='ind' @click='lick(j)' :class='{ "over": j.time }'
          v-if="j.lite != 181">
          {{ j.name }}</div>
      </div>
    </div>
    <!-- <div class="bot">
      <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='sub'>
        <a-button type="primary" style="width:148px;">
          保存
        </a-button>
      </a-popconfirm>
      <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;" @click="reset">取消</a-button>
    </div> -->
  </drag-modal>
</template>
<script>
export default {
  name: 'StepSel',
  props: {
    Step: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      stepTit: ["诉前准备", "一审", "二审", "重审", "再审", "审判监督", "执行"]
    }
  },
  computed: {
    StepArr() {
      let Arr = []
      for (let val in this.Step) {
        Arr = Arr.concat(this.Step[val])
      }
      return Arr
    }
  },

  methods: {
    close() {
      this.$store.dispatch('openkey', { key: 'stepbox', by: false })
    },
    lick(i) {
      if (i.time) return false;
      this.$store.dispatch('setkey', { key: 'StepLite', value: i.lite })
      this.$store.dispatch('setkey', { key: 'StepKey', value: i.keyName })
      setTimeout(e => {
        if (this.$common.AccAUTH(this.$store.state.cause.accuser.id, this.$store.state.editJA ? 'cause:step:ja:add' : this.$store.getters.stepPower.add)) {
          this.$emit("lite", i.element)
          this.close();
        }
        else {
          this.$message.error('暂无权限')
        }
      }, 100)

    }
  }
}
</script>
<style lang="less" scoped>
.dl {
  margin-bottom: 10px;

  .dt {
    font-size: 14px;
    color: #0e2949;
    line-height: 18px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .dd {
    display: flex;

    .a {
      width: 136px;
      line-height: 36px;
      background: #f1f5fa;
      border-radius: 4px;
      text-align: center;
      color: rgba(14, 41, 73, 0.3);
      margin-right: 15px;
      font-size: 13px;
      cursor: pointer;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
        color: #fff;
      }
    }

    .over {
      background: rgba(14, 41, 73, 0.1);
      color: #fff;

      &:hover {
        background: rgba(14, 41, 73, 0.1);
      }
    }
  }
}
</style>